import * as React from "react";
import { getLocalDateFromUTC } from "../../detail/form_utility";

class FormattedDateComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const value = this.props.dataItem[this.props.field];
    return <td>{this.getFromattedDate(value)}</td>;
  }

  private getFromattedDate = (value: any) => {
    return getLocalDateFromUTC(value);
  };
}

export default FormattedDateComponent;
